<template>
  <div class="w1">
    <div class="wrap-admin" >
      <div class="admin">
        <div div class="all-pages-list">
          <h1 class="page-header color-1-100">All landing pages</h1>
          <div class="content-section">
            <div class="data-list-body">
              <table class="table table-data">
                <thead>
                <tr>
                  <th class="table-head-ceil">
                    <div class="caption-head">
                      <div class="caption-head-text">
                        <span class="caption-head-inner-text">Page name</span>
                      </div>
                    </div>
                  </th>
                  <th colspan="2">
                    Actions
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td @click.prevent="goToPageEdit('edit-homepage')">Homepage</td>
                  <td style="width: 100px;" @click.prevent="importPage('homepage')">Import</td>
                  <td style="width: 100px;" @click.prevent="exportPage('homepage')">Export</td>
                </tr>
                <tr>
                  <td @click.prevent="goToPageEdit('edit-about')">About page</td>
                  <td style="width: 100px;" @click.prevent="importPage('about-us')">Import</td>
                  <td style="width: 100px;" @click.prevent="exportPage('about-us')">Export</td>
                </tr>
                <tr>
                  <td @click.prevent="goToPageEdit('edit-login')">Login page</td>
                  <td style="width: 100px;" @click.prevent="importPage('login-page')">Import</td>
                  <td style="width: 100px;" @click.prevent="exportPage('login-page')">Export</td>
                </tr>
<!--                <tr>-->
<!--                  <td @click.prevent="goToPageEdit('edit-download-brochure')">Download brochure page</td>-->
<!--                  <td style="width: 100px;" @click.prevent="importPage('download-brochure-page')">Import</td>-->
<!--                  <td style="width: 100px;" @click.prevent="exportPage('download-brochure-page')">Export</td>-->
<!--                </tr>-->
                <tr>
                  <td @click.prevent="goToPageEdit('edit-contact')">Contact page</td>
                  <td style="width: 100px;" @click.prevent="importPage('contact-page')">Import</td>
                  <td style="width: 100px;" @click.prevent="exportPage('contact-page')">Export</td>
                </tr>
                <!--<tr>
                  <td @click.prevent="goToPageEdit('edit-ask-expert')">Ask an expert</td>
                  <td style="width: 100px;" @click.prevent="importPage('ask-experts')">Import</td>
                  <td style="width: 100px;" @click.prevent="exportPage('ask-experts')">Export</td>
                </tr>-->
                <tr>
                  <td @click.prevent="goToPageEdit('edit-terms-and-conditions')">Terms and conditions</td>
                  <td style="width: 100px;" @click.prevent="importPage('terms-and-conditions')">Import</td>
                  <td style="width: 100px;" @click.prevent="exportPage('terms-and-conditions')">Export</td>
                </tr>
                <tr>
                  <td @click.prevent="goToPageEdit('edit-privacy-policy')">Privacy policy</td>
                  <td style="width: 100px;" @click.prevent="importPage('privacy-policy')">Import</td>
                  <td style="width: 100px;" @click.prevent="exportPage('privacy-policy')">Export</td>
                </tr>
                <tr>
                  <td @click.prevent="goToPageEdit('edit-accessibility-section')">Accessibility section</td>
                  <td style="width: 100px;" @click.prevent="importPage('accessibility-section')">Import</td>
                  <td style="width: 100px;" @click.prevent="exportPage('accessibility-section')">Export</td>
                </tr>
<!--                <tr>-->
<!--                  <td @click.prevent="goToPageEdit('edit-cookies')">Cookies</td>-->
<!--                  <td style="width: 100px;" @click.prevent="importPage('cookies')">Import</td>-->
<!--                  <td style="width: 100px;" @click.prevent="exportPage('cookies')">Export</td>-->
<!--                </tr>-->
                <tr>
                  <td @click.prevent="goToPageEdit('edit-give-consent')">Give consent page</td>
                  <td style="width: 100px;" @click.prevent="importPage('give-consent')">Import</td>
                  <td style="width: 100px;" @click.prevent="exportPage('give-consent')">Export</td>
                </tr>
                <tr>
                  <td @click.prevent="goToPageEdit('edit-confirm-subscription')">Confirm subscription page</td>
                  <td style="width: 100px;" @click.prevent="importPage('confirm-subscription')">Import</td>
                  <td style="width: 100px;" @click.prevent="exportPage('confirm-subscription')">Export</td>
                </tr>
<!--                <tr>-->
<!--                  <td @click.prevent="goToPageEdit('edit-clear-kit')">ClearKit page</td>-->
<!--                  <td style="width: 100px;" @click.prevent="importPage('clear-kit')">Import</td>-->
<!--                  <td style="width: 100px;" @click.prevent="exportPage('clear-kit')">Export</td>-->
<!--                </tr>-->
                <tr>
                  <td @click.prevent="goToPageEdit('edit-register')">Register page</td>
                  <td style="width: 100px;" @click.prevent="importPage('register')">Import</td>
                  <td style="width: 100px;" @click.prevent="exportPage('register')">Export</td>
                </tr>
                <tr>
                  <td @click.prevent="goToPageEdit('edit-callback-request')">Callback request</td>
                  <td style="width: 100px;" @click.prevent="importPage('callback-request')">Import</td>
                  <td style="width: 100px;" @click.prevent="exportPage('callback-request')">Export</td>
                </tr>
                <tr>
                  <td @click.prevent="goToPageEdit('edit-need-help')">Need help request</td>
                  <td style="width: 100px;" @click.prevent="importPage('need-help')">Import</td>
                  <td style="width: 100px;" @click.prevent="exportPage('need-help')">Export</td>
                </tr>
                <tr>
                  <td @click.prevent="goToPageEdit('edit-terms-of-service')">Terms of service</td>
                  <td style="width: 100px;" @click.prevent="importPage('terms-of-service')">Import</td>
                  <td style="width: 100px;" @click.prevent="exportPage('terms-of-service')">Export</td>
                </tr>
                </tbody>
              </table>
              <a href="#" v-show="false" id="exportLanding"></a>
              <input type="file" v-show="false" id="importLanding" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import api from '@/api'

  export default {
    name: 'admin',
    methods: {
      ...mapActions([
        'setFontSizeActive',
        'setColorPaletteActive'
      ]),
      goToPageEdit (page) {
        let props = this.$router.resolve({
          name: page
        })
        this.$router.push(props.href)
      },
      importPage (slug) {
        let page
        let self = this
        let input = document.getElementById('importLanding')
        input.addEventListener('change', function () {
          if (input.files && input.files[0]) {
            let reader = new FileReader()
            reader.onload = function (e) {
              page = JSON.parse(e.target.result)
              self.savePage(slug, page)
            }
            reader.readAsText(input.files[0])
          }
        }, false)
        input.click()
      },
      savePage (slug, page) {
        let pageData = {
          title: page.title,
          description: page.description,
          body: JSON.stringify(page.body),
          slug: slug
        }
        this.$http.post(api.URLS.staticpage, pageData, api.headersAuthSettings)
      },
      exportPage (slug) {
        let body = {
          slug: slug
        }
        this.$http.post(api.URLS.staticpage + '/' + slug, body, api.headersAuthSettings).then((res) => {
          let pageData = {
            title: res.data.title,
            description: res.data.description,
            body: JSON.parse(res.data.body)
          }
          let date = new Date()
          let dataStr = 'data:text/json;charset=utf-8,' + encodeURIComponent(JSON.stringify(pageData))
          let dlAnchorElem = document.getElementById('exportLanding')
          dlAnchorElem.setAttribute('href', dataStr)
          dlAnchorElem.setAttribute('download', slug + '_' + (date.getMonth() + 1) + '-' + date.getDate() + '-' + date.getFullYear() + '.json')
          dlAnchorElem.click()
          console.log(res)
        }).catch((err) => {
          console.log('err', err)
        })
      },
      consentCheck () {
        this.$http.put(api.URLS.profile, {}, api.headersAuthSettings).then((res) => {
          if (res.body.consent_status !== 1) {
            let props = this.$router.resolve({
              name: 'give-consent'
            })
            this.$router.push(props.href)
          }
        })
      }
    },
    created () {
      this.consentCheck()
      document.title = 'All landing pages | Clear Assured'
      if (window._paq) {
        window._paq.push(['setCustomUrl', location.pathname])
        window._paq.push(['setDocumentTitle', document.title])
        window._paq.push(['trackPageView'])
      }
      // if (window.ga) {
      //   window.ga('set', 'contentGroup1', 'ADMINISTRATION_AREA')
      //   window.ga('send', 'pageview', {
      //     'page': location.pathname,
      //     'location': location.href,
      //     'title': document.title
      //   })
      // }
    },
    mounted () {
      this.setFontSizeActive()
      this.setColorPaletteActive()
    }
  }
</script>

<style src='@/assets/scss/components/edit-pages-list.scss' lang='scss' scoped></style>
<style src='@/assets/scss/components/table.scss' lang='scss' ></style>



// WEBPACK FOOTER //
// EditLandingPages.vue?ee8d26bc